var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 18V16.3333C13.3335 15.4493 12.9823 14.6014 12.3572 13.9763C11.7321 13.3512 10.8842 13 10.0002 13H4.16683C3.28277 13 2.43493 13.3512 1.80981 13.9763C1.18469 14.6014 0.833496 15.4493 0.833496 16.3333V18",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08333 9.66667C8.92428 9.66667 10.4167 8.17428 10.4167 6.33333C10.4167 4.49238 8.92428 3 7.08333 3C5.24238 3 3.75 4.49238 3.75 6.33333C3.75 8.17428 5.24238 9.66667 7.08333 9.66667Z",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 9.66667L15.8332 11.3333L19.1665 8",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue);
export default __webpack_public_path__ + "static/media/value.9ac735a20bf5abc234e41e798b2ce565.svg";
export { ForwardRef as ReactComponent };